import styles from "./StepLayout.module.css";
import PatientCard from "./PatientCard";
import useCurrentLocation from "../../hooks/useCurrentLocation";
import { getBmiInfo, RightCard } from "../CareJourney/Heightweightscreen";
import { useState } from "react";
import { ScreenHeaderDFO } from "../HealthAssessment/SharedUI";

export default function StepLayout({
  title,
  subtitle,
  icon,
  patient,
  children,
  footer,
  noPad = false,
  initialValues = {}
}) {
  const location = useCurrentLocation();
  const { state } = location || {};
  const { latitude, longitude, district, loading, error } = location;
     const [heightIn, setHeightIn] = useState(initialValues.heightIn ?? 64);
    const [weightKg, setWeightKg] = useState(initialValues.weightKg ?? 60);
  const T = {
  purple700:   "var(--primary-color)",
  purpleBtn:   "var(--secondary-color)",
  purpleLight: "var(--ava-bg-primary-light)",
  heading:     "#1A1033",
  sub:         "#6B7280",
  muted:       "#9CA3AF",
  border:      "#E5E7EB",
  green:       "#10B981",
  amber:       "#F59E0B",
  red:         "#EF4444",
};
  // console.log(state, latitude, longitude, district, loading, error, "this is state")
  const bmi  = (weightKg / ((heightIn * 0.0254) ** 2)).toFixed(1);
  // console.log(state, latitude, longitude, district, loading, error, "this is state")
  const { label: bmiLabel, color: bmiColor } = getBmiInfo(bmi);
const BMI_RANGES = [
  { label: "Underweight", range: "< 18.5",      color: T.amber },
  { label: "Normal",      range: "18.5 – 24.9", color: T.green },
  { label: "Overweight",  range: "25 – 29.9",   color: T.amber },
  { label: "Obese",       range: "≥ 30",         color: T.red   },
];

  return (
    <>
        <ScreenHeaderDFO/>

    <div className={styles.root}>

      {/* ── Main card ── */}
      <div className={styles.main}>
        {(title || subtitle) && (
          <div className={`  ${styles.header}`} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              {icon && <div className={styles.headerIcon}>{icon}</div>}
              <div className="flex flex-col">
                {title && <h2 className={`ava-text-subheading ${styles.title}`}>{title}</h2>}
                {subtitle && <p className={`ava-text-body ${styles.subtitle}`}>{subtitle}</p>}
              </div>
            </div>
             <div className="hidden lg:flex ava-text-xs  items-center gap-2 whitespace-nowrap">
              {loading ? "Detecting..." : error ? "" : (
                <>
                  <span>📍</span>
                  <span className="ava-text-xs">{district ? `${district}, ` : ""}{state || ""}</span>
                </>
              )}
            </div>

            {/* <WizardStepper steps={STEPS} activeStep={activeStep} /> */}
          </div>
        )}

        <div className={noPad ? "" : styles.body}>
          {children}
        </div>

        {footer && <div className={styles.footer}>{footer}</div>}
      </div>

      {/* ── Sidebar ── */}
      {patient && (
        <div className={styles.sidebar} style={{display:"flex", flexDirection:"column", gap:"1rem"}}>
          <PatientCard patient={patient} />
          <div style={{ width: "100%", flexShrink: 0 }}>
            <RightCard>
               <p style={{ fontWeight: 700, fontSize: 12, color: T.heading }}>Why BMI matters</p>
            <p style={{ fontSize: 10, color: T.sub, lineHeight: 1.5, margin: 0 }}>
              BMI is a useful screening tool, but just one part of the picture. We combine it with your life stage and symptoms for a holistic view.
            </p>
            {BMI_RANGES.map(b => (
              <div key={b.label} style={{
                display: "flex", justifyContent: "space-between", alignItems: "center",
                padding: "5px 10px", borderRadius: 6,
                background: b.label === bmiLabel ? b.color + "20" : "transparent",
              }}>
                <span style={{ fontSize: 10, fontWeight: b.label === bmiLabel ? 700 : 400, color: b.label === bmiLabel ? b.color : T.sub }}>
                  {b.label}
                </span>
                <span style={{ fontSize: 10, color: T.muted }}>{b.range}</span>
              </div>
            ))}
            </RightCard>
          </div>
        </div>
      )}
    </div>
    </>
  );
}
